import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import useOutsideClick from '../../../common/utils/useOutsideClick';
import { FieldStatus, Input } from '@check24/form';
import { SuggestionsContainer, SuggestionsItem, SuggestionsTitle } from './StyledUndefinedContractsElements';
import styled from 'styled-components';

type AutocompleteInputPropsType = {
    setActiveProvider: Dispatch<SetStateAction<ProviderType>>;
    activeProvider: ProviderType;
    providerList: ProviderType[];
    loading: boolean;
    setActiveSearchValue: Dispatch<SetStateAction<string>>;
    activeSearchValue: string;
};

type ProviderType = {
    provider_id?: number | string;
    provider_name: string;
};

const StyledInputMobile = styled(Input.Mobile)`
    border-color: #949494;

    &:disabled {
        border-color: #949494;
    }

    label {
        color: #949494;
    }
`;

const AutocompleteInput = (props: AutocompleteInputPropsType) => {
    const { activeProvider, setActiveProvider, providerList, loading, setActiveSearchValue, activeSearchValue } = props;

    const [list, setList] = useState(providerList);

    const ref = useRef<HTMLDivElement | null>(null);
    const [selectedProvider, setSelectedProvider] = useState<string>('');
    const [isSuggestionContainerVisible, setIsSuggestionContainerVisible] = useState<boolean>(false);

    const onValueChange = (value: string) => {
        const filteredProvider = providerList.filter((item) => item.provider_name.toLowerCase().includes(value.toLowerCase()));

        if (activeProvider?.provider_id) {
            setActiveProvider({ provider_name: '' });
        }

        setActiveSearchValue(value);
        setList(filteredProvider);
    };

    useOutsideClick(ref, isSuggestionContainerVisible, () => {
        setIsSuggestionContainerVisible(false);
    });

    const handleListItemClick = (item: ProviderType) => {
        setSelectedProvider(item.provider_name);
        setActiveSearchValue(item.provider_name);
        setActiveProvider(item);
    };

    useEffect(() => {
        if (activeSearchValue === selectedProvider || !activeSearchValue.length) {
            setIsSuggestionContainerVisible(false);
        } else {
            setIsSuggestionContainerVisible(true);
        }
        return () => {
            setIsSuggestionContainerVisible(false);
        };
    }, [activeSearchValue, selectedProvider]);

    return (
        <>
            <StyledInputMobile
                value={activeSearchValue}
                valueLabel={'Ihr derzeitiger Anbieter'}
                placeholder={'Ihr derzeitiger Anbieter'}
                onChange={onValueChange}
                status={FieldStatus.UNTOUCHED}
                disabled={loading || !providerList.length}
            ></StyledInputMobile>
            <SuggestionsContainer ref={ref} show={isSuggestionContainerVisible}>
                <SuggestionsTitle>Meinen Sie</SuggestionsTitle>

                {list.map((item, index) => (
                    <SuggestionsItem key={`suggestions_item_${index}`} onClick={() => handleListItemClick(item)}>
                        {item.provider_name}
                    </SuggestionsItem>
                ))}

                {!list.length && (
                    <SuggestionsItem className={'no-result'}>Keinen passenden Anbieter gefunden</SuggestionsItem>
                )}
            </SuggestionsContainer>
        </>
    );
};

export default AutocompleteInput;
